export const environment = {
  production: true,
  apiBaseUrl: 'https://api.plantguardian.ch/v1',
};
